// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3JYFB","paramInput":"JobSimulator_paramInput__2wBzk","input":"JobSimulator_input__bq8U_"};